import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import { Input } from "components/bootstrap";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "integrations/aws/context/AdvancedOptions";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
const FormAdvancedOptions = ({ onChange, handleSqsMessageBatchSizeChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { overrideSource, awsCloudTrailThrottleEnabled, sqsMessageBatchSize, includeFullMessageJson } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandleSqsBatchSizeChange = (e) => {
    const { value } = e.target;
    onChange(e, formData);
    if (value >= 1 && value <= 10) {
      handleSqsMessageBatchSizeChange("");
    } else {
      handleSqsMessageBatchSizeChange("Please select SQS Message Batch Size between 1 - 10.");
    }
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "awsCloudTrailThrottleEnabled",
      defaultChecked: awsCloudTrailThrottleEnabled == null ? void 0 : awsCloudTrailThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "overrideSource",
      type: "text",
      value: overrideSource == null ? void 0 : overrideSource.value,
      onChange,
      label: "Override Source (optional)",
      help: "The source is set to aws-cloudtrail by default. If desired, you may override it with a custom value."
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "sqsMessageBatchSize",
      type: "number",
      min: "1",
      value: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
      onChange: internalHandleSqsBatchSizeChange,
      label: "SQS Message Batch Size",
      help: "The maximum number of messages to query from SQS at a time. The maximum acceptable value is 10."
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "includeFullMessageJson",
      type: "checkbox",
      checked: includeFullMessageJson == null ? void 0 : includeFullMessageJson.value,
      onChange,
      label: "Include full_message_json?",
      help: "Store the complete CloudTrail event as JSON in the full_message_json field?"
    }
  ));
};
export default FormAdvancedOptions;
